import { render, staticRenderFns } from "./filterCom.vue?vue&type=template&id=f53560a2&scoped=true"
import script from "./filterCom.vue?vue&type=script&lang=js"
export * from "./filterCom.vue?vue&type=script&lang=js"
import style0 from "./filterCom.vue?vue&type=style&index=0&id=f53560a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53560a2",
  null
  
)

export default component.exports